import React from 'react';
import logo from './logo.svg';
import './App.css';
import ImprovedEnterpriseLayoutPreview from './Layout/main_layout';
import LoginInterface from './login-interface';
import RequestsTestPage from './pages/RequestsTestPage';
import { Route, Routes } from 'react-router-dom';

function App() {
  return (


    <Routes>
        <Route path="/" element={<LoginInterface />} />
        <Route path="/login" element={<LoginInterface />} />
        <Route path="/app" element={<ImprovedEnterpriseLayoutPreview />} />
        <Route path="/requests-test" element={<RequestsTestPage />} />
        {/* other routes */}
      </Routes>
    // <ImprovedEnterpriseLayoutPreview/>
  );
}

export default App;
